import { useState, useEffect } from 'react';
import { useDataProvider } from '@refinedev/core';

interface PatientDues {
    total_due: number;
    currency?: string;
}

export const usePatientDues = (patientId: string | number | null) => {
    const [dues, setDues] = useState<PatientDues | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const getDataProvider = useDataProvider();

    useEffect(() => {
        const fetchPatientDues = async () => {
            if (!patientId) {
                setDues(null);
                return;
            }

            setLoading(true);
            setError(null);

            try {
                const dataProvider = getDataProvider();
                if (dataProvider && dataProvider.custom) {
                    const response = await dataProvider.custom({
                        url: `/clinic-invoices/patient-dues/${patientId}`,
                        method: 'get',
                    });

                    // Extract the sum_of_dues from the response
                    const sumOfDues = response.data?.data?.sum_of_dues || response.data?.sum_of_dues || 0;
                    setDues({ total_due: sumOfDues });
                } else {
                    throw new Error('DataProvider custom method not available');
                }
            } catch (err: any) {
                console.error('Error fetching patient dues:', err);
                setError(err?.response?.data?.message || 'Failed to fetch patient dues');
                setDues({ total_due: 0 });
            } finally {
                setLoading(false);
            }
        };

        fetchPatientDues();
    }, [patientId, getDataProvider]);

    return { dues, loading, error };
};
